import api from "PFCore/api";

export const deleteAttachment = (id) => {
  api({
    url: `attachments/${id}`,
    method: "DELETE"
  });
};
